export class GridFieldModel {
  constructor(public fieldName: string, public value: any, public title?: string) {}
}
